
export const UPDATE_ENTITE = 'UPDATE_ENTITE';

export const GET_ENTITE_REQUEST = 'GET_ENTITE_REQUEST';
export const GET_ENTITE_SUCCESS = 'GET_ENTITE_SUCCESS';
export const GET_ENTITE_FAIL = 'GET_ENTITE_FAIL';

export const GET_ALL_ENTITES_REQUEST = 'GET_ALL_ENTITES_REQUEST';
export const GET_ALL_ENTITES_SUCCESS = 'GET_ALL_ENTITES_SUCCESS';
export const GET_ALL_ENTITES_FAIL = 'GET_ALL_ENTITES_FAIL';

export const GET_ACTIVE_ENTITES_REQUEST = 'GET_ACTIVE_ENTITES_REQUEST';
export const GET_ACTIVE_ENTITES_SUCCESS = 'GET_ACTIVE_ENTITES_SUCCESS';
export const GET_ACTIVE_ENTITES_FAIL = 'GET_ACTIVE_ENTITES_FAIL';

export const GET_ENTITES_BY_CATEGORY_REQUEST = 'GET_ENTITES_BY_CATEGORY_REQUEST';
export const GET_ENTITES_BY_CATEGORY_SUCCESS = 'GET_ENTITES_BY_CATEGORY_SUCCESS';
export const GET_ENTITES_BY_CATEGORY_FAIL = 'GET_ENTITES_BY_CATEGORY_FAIL';

export const CREATE_ENTITE_REQUEST = 'CREATE_ENTITE_REQUEST';
export const CREATE_ENTITE_SUCCESS = 'CREATE_ENTITE_SUCCESS';
export const CREATE_ENTITE_FAIL = 'CREATE_ENTITE_FAIL';

export const UPDATE_ENTITE_REQUEST = 'UPDATE_ENTITE_REQUEST';
export const UPDATE_ENTITE_SUCCESS = 'UPDATE_ENTITE_SUCCESS';
export const UPDATE_ENTITE_FAIL = 'UPDATE_ENTITE_FAIL';

export const DELETE_ENTITE_REQUEST = 'DELETE_ENTITE_REQUEST';
export const DELETE_ENTITE_SUCCESS = 'DELETE_ENTITE_SUCCESS';
export const DELETE_ENTITE_FAIL = 'DELETE_ENTITE_FAIL';

export const SET_ENTITE_LOADING = 'SET_ENTITE_LOADING';
export const GET_ORGANIGRAMME_REQUEST = "GET_ORGANIGRAMME_REQUEST";
export const GET_ORGANIGRAMME_SUCCESS = "GET_ORGANIGRAMME_SUCCESS";
export const GET_ORGANIGRAMME_FAIL = "GET_ORGANIGRAMME_FAIL";

export const IMPORT_ENTITIES_EXCEL_REQUEST = "IMPORT_ENTITIES_EXCEL_REQUEST";
export const IMPORT_ENTITIES_EXCEL_SUCCESS = "IMPORT_ENTITIES_EXCEL_SUCCESS";
export const IMPORT_ENTITIES_EXCEL_FAIL    = "IMPORT_ENTITIES_EXCEL_FAIL";

export const EXPORT_ENTITIES_REQUEST = "EXPORT_ENTITIES_REQUEST";
export const EXPORT_ENTITIES_SUCCESS = "EXPORT_ENTITIES_SUCCESS";
export const EXPORT_ENTITIES_FAIL    = "EXPORT_ENTITIES_FAIL";

export const DOWNLOAD_ENTITIES_TEMPLATE_REQUEST = "DOWNLOAD_ENTITIES_TEMPLATE_REQUEST";
export const DOWNLOAD_ENTITIES_TEMPLATE_SUCCESS = "DOWNLOAD_ENTITIES_TEMPLATE_SUCCESS";
export const DOWNLOAD_ENTITIES_TEMPLATE_FAIL    = "DOWNLOAD_ENTITIES_TEMPLATE_FAIL";

// ========================================
// 🎬 ACTION CREATORS
// ========================================


export const importEntitiesExcelRequest = (file, dryRun, action) => ({
    type: IMPORT_ENTITIES_EXCEL_REQUEST,
    payload: { file, dryRun, action },
});
export const exportEntitiesRequest       = () => ({ type: EXPORT_ENTITIES_REQUEST });
export const downloadEntitiesTemplateRequest = () => ({ type: DOWNLOAD_ENTITIES_TEMPLATE_REQUEST });

//organigramme
export const getOrganigrammeRequest = () => ({ type: GET_ORGANIGRAMME_REQUEST });
export const getOrganigrammeSuccess = (data) => ({ type: GET_ORGANIGRAMME_SUCCESS, payload: data });
export const getOrganigrammeFail = (err) => ({ type: GET_ORGANIGRAMME_FAIL, payload: err });
///
export const updateEntite = (entite) => {
    return {
        type: UPDATE_ENTITE,
        entite
    };
}

// --- Récupérer un entité par ID ---
export const getEntiteRequest = (entiteId) => ({
    type: GET_ENTITE_REQUEST,
    payload: { entiteId }
});

export const getEntiteSuccess = (entite) => ({
    type: GET_ENTITE_SUCCESS,
    payload: entite
});

export const getEntiteFail = (error) => ({
    type: GET_ENTITE_FAIL,
    error
});

// --- Récupérer tous les entités ---
export const getAllEntitesRequest = () => ({
    type: GET_ALL_ENTITES_REQUEST
});

export const getAllEntitesSuccess = (entites) => ({
    type: GET_ALL_ENTITES_SUCCESS,
    payload: entites
});

export const getAllEntitesFail = (error) => ({
    type: GET_ALL_ENTITES_FAIL,
    error
});

// --- Récupérer les entités actifs ---
export const getActiveEntitesRequest = () => ({
    type: GET_ACTIVE_ENTITES_REQUEST
});

export const getActiveEntitesSuccess = (entites) => ({
    type: GET_ACTIVE_ENTITES_SUCCESS,
    payload: entites
});

export const getActiveEntitesFail = (error) => ({
    type: GET_ACTIVE_ENTITES_FAIL,
    error
});

// --- Récupérer entités par catégorie ---
export const getEntitesByCategoryRequest = (category) => ({
    type: GET_ENTITES_BY_CATEGORY_REQUEST,
    payload: { category }
});

export const getEntitesByCategorySuccess = (entites) => ({
    type: GET_ENTITES_BY_CATEGORY_SUCCESS,
    payload: entites
});

export const getEntitesByCategoryFail = (error) => ({
    type: GET_ENTITES_BY_CATEGORY_FAIL,
    error
});

// --- Créer un entité ---
export const createEntiteRequest = (entiteData, history) => ({
    type: CREATE_ENTITE_REQUEST,
    payload: entiteData,
    history
});

export const createEntiteSuccess = (entite) => ({
    type: CREATE_ENTITE_SUCCESS,
    payload: entite
});

export const createEntiteFail = (error) => ({
    type: CREATE_ENTITE_FAIL,
    error
});

// --- Mettre à jour un entité ---
export const updateEntiteRequest = (entiteId, entiteData) => ({
    type: UPDATE_ENTITE_REQUEST,
    payload: { entiteId, entiteData }
});

export const updateEntiteSuccess = (entite) => ({
    type: UPDATE_ENTITE_SUCCESS,
    payload: entite
});

export const updateEntiteFail = (error) => ({
    type: UPDATE_ENTITE_FAIL,
    error
});

// --- Supprimer un entité ---
export const deleteEntiteRequest = (entiteId) => ({
    type: DELETE_ENTITE_REQUEST,
     entiteId ,

});

export const deleteEntiteSuccess = (entiteId) => ({
    type: DELETE_ENTITE_SUCCESS,
    payload: { entiteId }
});

export const deleteEntiteFail = (error) => ({
    type: DELETE_ENTITE_FAIL,
    error
});

// --- Loading ---
export const setEntiteLoading = (loading) => ({
    type: SET_ENTITE_LOADING,
    payload: loading
});